export const userInputs = [
  {
    id: "username",
    label: "Username",
    type: "text",
    placeholder: "type username",
  },
  {
    id: "fullname",
    label: "Full Name",
    type: "text",
    placeholder: "type full name",
  },
  {
    id: "email",
    label: "Email",
    type: "email",
    placeholder: "type email",
  },
  {
    id: "phone",
    label: "Phone",
    type: "text",
    placeholder: "type phone number",
  },
  {
    id: "password",
    label: "Password",
    type: "password",
    placeholder: "type password",
  },
  {
    id: "address",
    label: "Address",
    type: "text",
    placeholder: "type address",
  },
  {
    id: "country",
    label: "Country",
    type: "text",
    placeholder: "type country",
  },
];

export const ticketInputs = [
  {
    id: "subject",
    label: "Subject",
    placeholder: "Enter subject here...",
    type: "text",
  },
  {
    id: "status",
    label: "Status",
    type: "select",
    options: ["Open", "In Progress", "Resolved", "Closed"],
  },
];

export const signupInputs = [
  {
    id: "fullname",
    label: "Full Name",
    type: "text",
    placeholder: "type full name",
  },
  {
    id: "username",
    label: "Username",
    type: "text",
    placeholder: "type username",
  },
  {
    id: "email",
    label: "Email",
    type: "email",
    placeholder: "type email",
  },
  {
    id: "password",
    label: "Password",
    type: "password",
    placeholder: "type password",
  },
];
